import auth from '../../../services/authService';
import theme from '../../../utils/theme';
import { removeColorTheme } from '../../../utils/colorTheme';

const SignOut = () => {
  auth.signout();
  window.location = '/signin';
  theme.removeDarkTheme();
  removeColorTheme();

  return null;
};

export default SignOut;
